import { SaleModel } from '../../../../../models/sale/Sale';

interface Props {
  sale: SaleModel;
}

export function SaleListItemRibon({ sale }: Props) {
  if (!sale.is_rec && !sale.is_new) return null;

  const isRec = !!sale.is_rec;
  const size = isRec ? 76 : 63;
  const color = isRec ? '#FFD000' : '#e53935';
  const label = isRec ? 'おすすめ' : 'NEW';
  const fontSize = isRec ? '13px' : '16px';
  const top = isRec ? '22px' : '13px';

  return (
    <>
      {isRec && (
        <style>{`
          @keyframes recShine {
            0%,55%  { transform: skewX(-15deg) translateX(-80px); opacity: 0; }
            65%     { opacity: 0.9; }
            85%     { opacity: 0.9; }
            100%    { transform: skewX(-15deg) translateX(160px); opacity: 0; }
          }
        `}</style>
      )}
      {/* 三角リボン */}
      <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: 0,
        height: 0,
        borderStyle: 'solid',
        borderWidth: `0 ${size}px ${size}px 0`,
        borderColor: `transparent ${color} transparent transparent`,
        filter: 'drop-shadow(-2px 2px 3px rgba(0,0,0,0.35))',
      }} />
      {/* キラリ光沢（おすすめのみ） */}
      {isRec && (
        <div style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: size,
          height: size,
          overflow: 'hidden',
          clipPath: 'polygon(100% 0, 0 0, 100% 100%)',
          pointerEvents: 'none',
        }}>
          <div style={{
            position: 'absolute',
            top: '-20%',
            left: 0,
            width: '30%',
            height: '140%',
            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.85), transparent)',
            animationName: 'recShine',
            animationDuration: '2.5s',
            animationTimingFunction: 'ease-in-out',
            animationIterationCount: 'infinite',
            animationDelay: '0.8s',
          }} />
        </div>
      )}
      {/* ラベルテキスト */}
      <span style={{
        position: 'absolute',
        top,
        right: isRec ? '-4px' : '0px',
        color: '#fff',
        fontSize,
        fontWeight: '900',
        letterSpacing: '1.5px',
        lineHeight: 1,
        transform: 'rotate(45deg)',
        textShadow: isRec
          ? '0 0 6px rgba(0,0,0,1), 0 1px 4px rgba(0,0,0,0.9)'
          : '0 1px 3px rgba(0,0,0,0.5)',
        WebkitTextStroke: isRec ? '0.4px rgba(0,0,0,0.5)' : undefined,
        pointerEvents: 'none',
      }}>{label}</span>
    </>
  );
}
